<template>
  <div>
    <div ref="shortlistCounter" class="shortlist-counter" title="Add villas to your shortlist">
      <span v-if="!isEmpty" ref="shortlistCounterAmount" class="shortlist-counter-amount">
        {{ shortlistAmount }}
      </span>

      <Heart class="heart-icon" :color="color" :isActive="isActive" />
    </div>
  </div>
</template>

<script>
import Heart from '../../icons/Heart.vue';

export default {
  components: {
    Heart,
  },
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shortlistAmount() {
      if (this.$store.getters['common/getShortlist'] && this.$store.getters['common/getShortlist'].length !== 0) {
        this.animateShortlistCounter();
      }
      return this.$store.getters['common/getShortlist'] ? this.$store.getters['common/getShortlist'].length : 0;
    },
    enquiryRedirect() {
      return 'send an enquiry';
    },
    isEmpty() {
      return this.$store.getters['common/getShortlist'].length === 0;
    },
  },
  methods: {
    animateShortlistCounter() {
      const { shortlistCounterAmount } = this.$refs;

      if (shortlistCounterAmount) {
        gsap.to(shortlistCounterAmount, 0.5, {
          ease: 'bounce.out',
          y: -10,
        });

        gsap.to(shortlistCounterAmount, 0.5, {
          ease: 'bounce.in',
          y: 0,
          delay: 0.5,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/settings/config.scss";

.shortlist {
  &-counter {
     position: relative;
     display: flex;
     align-items: center;
     justify-content: center;
     &-amount {
      top: 7px;
      right: -3px;
      position: absolute;
      background: $lunarioAcid;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      text-align: center;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
    }
  }
}

.heart-icon {
  display: block;
  width: 20px;
  height: 19px;
}
</style>
